import { createSelector } from '@reduxjs/toolkit';

import { FiltersPositionEnum } from '@/interfaces/settings.interfaces';

import configSelector from './config';

/**
 * Получить расположение блока фильтров из настроек приложения
 */
const filtersPositionSelector = createSelector(
  configSelector,
  ({ filters }) => filters.position || FiltersPositionEnum.Left,
);

export default filtersPositionSelector;
